import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const CharacteristicsName = styled(Paragraph4)`
    white-space: nowrap;
`;

export const CharacteristicsDevider = styled.div`
    flex: 1 0 38px;
    height: 14px;
    margin-bottom: 5px;
    border-bottom: 1px dashed ${COLORS.TextSecondary};
`;

export const CharacteristicsValue = styled(CharacteristicsName)<{ isFullView: boolean }>`
    ${({ isFullView }) => isFullView
        ? css`
            position: absolute;
            top: 0;
            right: 0;
            width: auto;
            padding: 0 5px;
            border-radius: 5px;
            background-color: ${COLORS.BgSurface};
        `
        : css`
            position: static;
            max-width: 115px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            @media (min-width: ${wideBreakpoints.sMobile}) {
                max-width: 150px;
            }
        `
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        position: static;
        max-width: unset;
        width: auto;
        padding: 0;
        border-radius: unset;
        background-color: unset;
    }
`;
